var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOut = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 12 12"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#out_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m9.24 9.547-.42-.335a4.59 4.59 0 0 1-3.283 1.398A4.62 4.62 0 0 1 .926 5.998a4.62 4.62 0 0 1 4.611-4.611c1.286 0 2.443.54 3.283 1.397l.42-.334s.154-.103.377-.172A5.52 5.52 0 0 0 5.537.461 5.546 5.546 0 0 0 0 5.998a5.546 5.546 0 0 0 5.537 5.537 5.5 5.5 0 0 0 4.08-1.817 1.6 1.6 0 0 1-.377-.171"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.949 5.854s-.96-1.028-1.895-1.663a.3.3 0 0 0-.12-.043c-.043 0-.085 0-.12.026a.24.24 0 0 0-.128.206v.797s-4.32.137-4.406.197c-.12.086-.206.377-.206.609s.086.488.206.574c.086.06 4.406.231 4.406.231v.806a.24.24 0 0 0 .128.206.24.24 0 0 0 .24-.009c.935-.634 1.86-1.62 1.895-1.663a.23.23 0 0 0 0-.291z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "out_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
})))));
export default SvgOut;